export default "__VITE_ASSET__CRqL6Wsv__"